import React from "react";

import { useSelector } from "react-redux";

import {
  DeploymentPermissions,
  SaleyardPermissions,
} from "constants/permissions";
import { MissingFieldsIndicatorTypes } from "constants/saleLots";

import {
  selectIsUnderValidationThersholdBySaleLotId,
  selectNASFieldWarningsBySaleLotId,
} from "selectors";

import {
  useHasSaleyardOrDeploymentPermission,
  useGetMissingFieldWarnings,
} from "hooks";
import { NASMissingFieldsIndicatorProps } from "./types";
import {
  MissingFieldsIndicatorBase,
  defaultNutrienWarnings,
} from "./MissingFieldsIndicator";

export const checkUnderThreshold = (validations, modelIds) =>
  modelIds.some(modelId => {
    const validationToCheck = validations[modelId] || {};
    return (
      validationToCheck.missingDentition || validationToCheck.missingWeightRange
    );
  });

export function NASMissingFieldsIndicator(
  props: NASMissingFieldsIndicatorProps,
): React.JSX.Element {
  const { keyValue, onlyAdvancedFields = false } = props;

  const hasDentitionPermission = useHasSaleyardOrDeploymentPermission(
    DeploymentPermissions.featureDentition,
    SaleyardPermissions.featureDentition,
  );

  const hasWeightRangePermission = useHasSaleyardOrDeploymentPermission(
    DeploymentPermissions.featureWeightRange,
    SaleyardPermissions.featureWeightRange,
  );

  const hasMissingNasFieldsSaleLotIdLookup = useSelector(
    selectNASFieldWarningsBySaleLotId,
  );

  let keyValues = keyValue;
  if (!Array.isArray(keyValues)) {
    keyValues = [keyValues];
  }

  const warnings = useGetMissingFieldWarnings({
    modelIds: keyValues,
    lookup: hasMissingNasFieldsSaleLotIdLookup,
    defaultWarnings: defaultNutrienWarnings,
  });

  const validations = useSelector(selectIsUnderValidationThersholdBySaleLotId);
  const underThreshold = checkUnderThreshold(validations, keyValues);

  if (
    !hasWeightRangePermission ||
    !hasDentitionPermission ||
    onlyAdvancedFields
  ) {
    return null;
  }

  return (
    <MissingFieldsIndicatorBase
      label={MissingFieldsIndicatorTypes.NAS}
      warnings={warnings}
      areFieldsUnderWarningThreshold={underThreshold}
    />
  );
}
